import React from 'react'
import { createPortal } from 'react-dom'
import _ from 'lodash'
import Tracker from '../../services/Tracker'
import getSortOptions from './sortOptions'
import { CheckIcon, CloseIcon } from './icons'

// Slide-up sheet for sort options on mobile.

const tracker = new Tracker()

export default function MobileSortDrawer({ model, changeState, search, onClose }) {
  const currentCode = (model.filters.sort_by && model.filters.sort_by.query && model.filters.sort_by.query.code) || ''
  const options = getSortOptions(model)
  // DEV-2980: the storefront's sort sheet applies on tap, no Apply step.
  function apply(staged) {
    if (staged === currentCode) { onClose(); return }

    const updated = _.cloneDeep(model)
    updated.filters.sort_by.query.code = staged
    updated.filters.sort_by.on = false
    delete updated.filters.ab
    updated.filters.pagination.page = 1

    changeState(updated)
    search({ m: updated })

    const source = location.pathname.toLowerCase() === '/search' ? 'Search 2.0' : 'Home Page'
    try {
      tracker.trackSortFilterClick({ source, v1: currentCode, v2: staged })
    } catch (err) {
      // Tracker failure should not block sort change.
    }

    document.dispatchEvent(new CustomEvent('update-listing-filters', {
      detail: { filters: updated.filters }
    }))
    onClose()
  }

  return createPortal(
    <div className="sfc">
      <div className="mno-backdrop" onClick={onClose} aria-hidden="true" />
      <div className="mno-sheet" role="dialog" aria-label="Sort lots">
        <div className="mno-sheet-head">
          <button type="button" className="mno-close" onClick={onClose} aria-label="Close sort">
            <CloseIcon />
          </button>
          <h2 className="mno-sheet-title">Sort by</h2>
          <span aria-hidden="true" />
        </div>
        <div className="mno-sheet-body">
          <ul className="mno-sort-list">
            {options.map(([code, label]) => (
              <li key={code}>
                <button
                  type="button"
                  className={'mno-sort-row' + (code === currentCode ? ' is-active' : '')}
                  onClick={() => apply(code)}
                >
                  <span>{label}</span>
                  {code === currentCode && <CheckIcon />}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>,
    document.body
  )
}
